import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {Section, SimpleSection} from '../components/Section';
import LoginForm from '../components/content-types/LoginForm';
import UserProfile from '../components/UserProfile';
import LoadingSpinner from '../components/LoadingSpinner';

const UserPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <LoadingSpinner message="Loading user account..." />;
  }

  if (!isAuthenticated) {
    return (
      <SimpleSection>
        <h2 className="mb-4">User Account</h2>
        <div className="card">
          <div className="card-body">
            <h3>Login/Register</h3>
            <LoginForm onSignIn={() => checkAuthStatus()} />
          </div>
        </div>
      </SimpleSection>
    );
  }

  return (<>
    <SimpleSection>
      <h2 className="mb-4">User Account</h2>
      <UserProfile onSignOut={() => setIsAuthenticated(false)} />
    </SimpleSection>
    <Section>
      <Row>
        <Col>
          <h3 className="mb-4">Challenge Submissions</h3>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-4">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>Submit Solution</Card.Title>
              <Card.Text>
                Submit your solution to the Quantum City Challenge. Share your code repository or deployed application.
              </Card.Text>
              <div className="mt-auto">
                <Link to="/user/submit">
                  <Button variant="primary">Submit Solution</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>View Submissions</Card.Title>
              <Card.Text>
                View all your previous submissions to the Quantum City Challenge and check their status.
              </Card.Text>
              <div className="mt-auto">
                <Link to="/user/submissions">
                  <Button variant="outline-primary">View Submissions</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
    <Section>
      <Row>
        <Col>
          <h3 className="mb-4">Questions & Support</h3>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-4">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>Ask a Question</Card.Title>
              <Card.Text>
                Have a question about the challenge? Ask our team for clarification or support.
              </Card.Text>
              <div className="mt-auto">
                <Link to="/user/ask">
                  <Button variant="primary">Ask Question</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card className="h-100">
            <Card.Body className="d-flex flex-column">
              <Card.Title>My Questions</Card.Title>
              <Card.Text>
                View all your questions and answers from the challenge team.
              </Card.Text>
              <div className="mt-auto">
                <Link to="/user/questions">
                  <Button variant="outline-primary">View Questions</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  </>);
};

export default UserPage;
